import { render, staticRenderFns } from "./Form25RepresentativesResolution.vue?vue&type=template&id=668c8c8c&scoped=true&"
import script from "./Form25RepresentativesResolution.vue?vue&type=script&lang=js&"
export * from "./Form25RepresentativesResolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668c8c8c",
  null
  
)

export default component.exports